import React from 'react';
import { useRef, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import API from '../../../lib/api';

import Modal from '../../../components/UI/Modal/Modal';
import Button from '../../../components/UI/Button/Button';

//import AuthContext from '../../store/auth-context';
import { getAuthToken } from '../../../components/util/auth';

import classes from './Profile.module.css';
import styles from '../../../components/UI/Form/FormGenerator/FormGenerator.module.css';

import { API_UPDATE_PWD } from '../Auth/AuthForm';

const ChangePassword = () => {
  const [msg, setMsg] = useState( null );
  const [errorMsg, setErrorMsg] = useState( null );
  const navigate = useNavigate();

  const oldPasswordInputRef = useRef();
  const newPasswordInputRef = useRef();
  const newPasswordInputRef2 = useRef();
  //const authCtx = useContext(AuthContext);
  
  const submitHandler = (event) => {
    event.preventDefault();

    const enteredNewPassword = newPasswordInputRef.current.value;
    const enteredNewPassword2 = newPasswordInputRef2.current.value;

    // add validation
    if ( enteredNewPassword.length < 7 ){
      setErrorMsg( 'Passwort zu kurz (min. 7 Zeichen)!' );
      return;
    }

    if ( enteredNewPassword != enteredNewPassword2 ) {
      setErrorMsg( 'Passwörter stimmen nicht überein!' );
      return;

    } else {

      const token = getAuthToken();      
      const cfg = API.auth_cfg( token );
      
      const enteredOldPassword = oldPasswordInputRef.current.value;

      const body = {
        oldPassword: enteredOldPassword,
        newPassword: enteredNewPassword
      }
      
      API.req( API.updatePwd, 'put', body, cfg )
      .then((data) => {
        console.log("Submitted");
        setMsg("Passwort geändert");
      })
      .catch( (err) => {
        console.log( err.message );
        setErrorMsg( err.message );
      });
      
      
      // fetch( API.updatePwd, {
        //   method: 'POST',
        //   body: JSON.stringify({
          //     idToken: getAuthToken(), //authCtx.token,
          //     password: enteredNewPassword,
          //     returnSecureToken: false
          //   }),
          //   headers: {
            //     'Content-Type': 'application/json'
            //   }
            // }).then(res => {
              //   // assumption: Always succeeds!
              
              //   navigate.replace('/');
              // });
    }
  };

  return <>
    { msg && 
      <Modal show={!!msg}
        modalClosed={() => { setMsg(null) }}
        className = 'success'>
          <div>{msg}</div>
      </Modal>
    }
    { errorMsg && 
      <Modal show={!!errorMsg}
        modalClosed={() => { setErrorMsg(null) }}
        className = 'error'>
          <div>{errorMsg}</div>
      </Modal>
    }
    <form className={styles.formcontainer} onSubmit={submitHandler}>
      <div className={styles.InputContainer}>
        <div className={styles.Label}>
          <label>Altes Passwort</label>
        </div>
        <div className={styles.Input}>
          <input className={styles.InputElement}
            type='password' 
            id='old-password'
            ref={oldPasswordInputRef} />
        </div>
        <div className={styles.Label} style={{marginTop: "20px"}}>
          <label>Neues Passwort</label>
        </div>
        <div className={styles.Input}>
          <input className={styles.InputElement}
            type='password' 
            id='new-password'
            ref={newPasswordInputRef} />
        </div>
        <div className={styles.Label}  style={{marginTop: "20px"}}>
          <label>Neues Passwort wiederholen</label>
        </div>
        <div className={styles.Input}>
          <input className={styles.InputElement}
            type='password' 
            id='new-password2'
            ref={newPasswordInputRef2} />
        </div>
        <div className={styles.Break}></div>
        <div className={styles.InputContainer} style={{marginTop: "20px"}}>
          <Button btnType="Success">
            Passwort ändern
          </Button>
        </div>
      </div>
    </form>
  </>
};

export default ChangePassword;
